/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_PositionInputs */

const en_field_position = /** @type {(inputs: Field_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Field_PositionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_position = /** @type {((inputs?: Field_PositionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_PositionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_position(inputs)
});